export const DOCUMENT_APPROVAL_STATUS_TO_APPROVE = 'to_approve';
export const DOCUMENT_APPROVAL_STATUS_NEGOTIATION = 'negotiation';
export const DOCUMENT_APPROVAL_STATUS_APPROVED = 'approved';
export const DOCUMENT_APPROVAL_STATUS_REJECTED = 'rejected';
export const DOCUMENT_APPROVAL_STATUS_REMOVED = 'removed';
export const DOCUMENT_APPROVAL_STATUS_REVISION = 'revision';
export const DOCUMENT_APPROVAL_STATUS_UNDEFINED = 'undefined';
